/**
 * Mirror of `ImageType` from `@vizit/api`. Duplicated here so this constants
 * package can stay free of API dependencies; kept in sync with the generated
 * type.
 */
export type SparkImageType = 'hero' | 'carousel';

/**
 * Centralized mapping from Spark Image parent type to the values derived from
 * it. Keep all `imageType` branches here so adding a new type fails the
 * `satisfies` check until every field is provided.
 *
 * - `sortBy`     — `sort_by` field for the search-images query.
 * - `container`  — DnD container key (matches `DragContainer` in
 *                  `@vizit/products/types/drag-drop`).
 * - `category`   — DnD category (matches `DraggableAssetData['category']`).
 */
export const SPARK_IMAGE_TYPE_CONFIG = {
  hero: { sortBy: 'hero_score', container: 'asset-drawer', category: 'hero' },
  carousel: { sortBy: 'vizit_score', container: 'spark-carousel', category: 'spark' },
} as const satisfies Record<
  SparkImageType,
  { sortBy: 'hero_score' | 'vizit_score'; container: 'asset-drawer' | 'spark-carousel'; category: 'hero' | 'spark' }
>;
